import type { Checklist } from '../types';

export const checklists: Checklist[] = [
  {
    "id": "日班",
    "title": "保全日班勤務 版本2026-08-08",
    "role": [
      "day",
      "night",
      "committee"
    ],
    "items": [
      {
        "id": "日班_001",
        "text": "07:00 上睄",
        "type": "check",
        "required": true,
        "hint": "- 拍照及檢查前一班檢查表執行情形,上傳Line群組作為上下班打卡依據, 晚於7:00要說明\n  **預計x月x日19:xx下班**\n- 檢查表按右上角的**重設**, 清除前一班檢查表的所有核對情形\n- 再檢查黃色名牌表更換成自己\n- 檢查檢查表打勾方式參考全日檢查表第一項\n- 包裹項目交接\n- 門禁設備每天校時,水電度數異常回報(機動班省略)\n  - [門禁系統共5處](http://d27:8888/docs/門禁系統使用手冊/校時.html)\n  - [水電記錄表](https://docs.google.com/spreadsheets/d/1W8hfwUIcB2Y2gyWP6WGLY7njaT9Kc8Z8Iiq3H9rbDB0/edit?usp=sharing)\n    填寫備註, 分析是否發生設備異常(漏水/漏電/抽水馬達開了沒效)"
      },
      {
        "id": "日班_002",
        "text": "07:15-07:30 到信箱核對智生活未領包裹戶別是否一致，拿掉已經領走的吊牌",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_003",
        "text": "07:30-08:30 平日站哨, 法定假日不用.沒下雨時，開啟前澆花系統約30分鐘",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_004",
        "text": "08:30 下雨天時，關閉前澆花系統",
        "type": "check",
        "required": true,
        "hint": "- 拿鑰匙打開B1機電室門\n- 找到[電磁閥控制箱](http://d27:8888/?view=docs), **澆灌系統**切換成**停止**"
      },
      {
        "id": "日班_005",
        "text": "09:00-18:00 收發信件包裹, 要使用智生活記錄掃包裹條碼及拍照(郵件包裹/寄放物品/退貨都必須以電子方式登記，並在物品上貼上智生活給的編號)",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_006",
        "text": "09:00-09:30 確認自動灑水運作正常, 改人工灑水或有異常須回報",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_007",
        "text": "12:00-14:00 對講機通知",
        "type": "check",
        "required": true,
        "hint": "除**不通知領取**紙條標注的住戶外, 對講機通知完, 儘速使用智生活**再通知**一次作為電子稽催記錄"
      },
      {
        "id": "日班_008",
        "text": "09:30 關閉B1車道門.如果垃圾車9：30後才來要協助進出車道",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_009",
        "text": "14:00-15:00 派發一般信件至住戶信箱以及若有未領包裹掛牌, 目前社區停止使用電子信箱鎖, 不要推太前面將信箱上鎖",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_010",
        "text": "16:45-17:00 確認自動灑水運作正常, 改人工灑水或有異常須回報",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_011",
        "text": "18:00 平日開啟B1車道門,法定假日不用開啟",
        "type": "check",
        "required": true
      },
      {
        "id": "日班_012",
        "text": "17:00-18:30 樓層巡邏、巡視各設備庫房狀況, 天暗時,開啟燈光",
        "type": "check",
        "required": true,
        "hint": "- 1F燈光黃標籤手動打開\n- 1F燈光綠標籤手動打開(4+2+1個)\n- 1F外圍走道手動打開, 開關在1F健身房前面走道變電箱打開左下角三個燈(綠標籤)\n- 1F梯廳藝術燈手動打開(1個)\n- 2F-10F梯廳燈打開(各層樓左邊有兩個開關, 打開右邊的一個,左邊關掉)\n- 垃圾冷凍櫃溫度(高於15度異常), B1, B2各設備燈號, 異常再拍照"
      },
      {
        "id": "日班_013",
        "text": "19:00 交接下哨, 黃色名牌換成夜班, 避免下班被打電話",
        "type": "check",
        "required": true
      }
    ]
  },
  {
    "id": "夜班",
    "title": "保全夜班勤務 版本2026-08-08",
    "role": [
      "day",
      "night",
      "committee"
    ],
    "items": [
      {
        "id": "夜班_001",
        "text": "19:00 上睄",
        "type": "check",
        "required": true,
        "hint": "- 拍照及檢查前一班檢查表執行情形,上傳Line群組作為上下班打卡依據, 晚於19:00要說明\n  **預計x月x日07:xx下班**\n- 檢查表按右上角的**重設**, 清除前一班檢查表的所有核對情形\n- 再檢查黃色名牌表更換成自己\n- 檢查檢查表打勾方式參考全日檢查表第一項\n- 包裹項目交接\n- 門禁設備每天校時\n  - [門禁系統共5處](http://d27:8888/docs/門禁系統使用手冊/校時.html)"
      },
      {
        "id": "夜班_002",
        "text": "19:15-20:00 平日站哨",
        "type": "check",
        "required": true,
        "hint": "假日不站,但住戶經過仍須站起來打招呼"
      },
      {
        "id": "夜班_003",
        "text": "20:00-21:00 對講機通知**未領取包裹**",
        "type": "check",
        "required": true,
        "hint": "除**不通知領取**紙條標注的住戶外, 對講機通知完, 儘速使用智生活**再通知**一次作為電子稽催記錄"
      },
      {
        "id": "夜班_004",
        "text": "21:00 關閉B1車道門, 交誼廳及健身房除濕機倒水, 檢查自動關閉景觀燈",
        "type": "check",
        "required": true
      },
      {
        "id": "夜班_005",
        "text": "22:00 巡邏1F,B1,B2, 巡視各設備庫房狀況",
        "type": "check",
        "required": true,
        "hint": "- 手動關1F關1F多餘燈光,只留綠標簽燈(4+2+1),\n- 手動關1F外圍走道燈, 開關在1F健身房前面走道變電箱打開左下角三個燈(綠標籤)\n- 垃圾冷凍櫃溫度(高於15度異常), B1,B2各設備燈號, 異常再拍照\n- B1抄下電錶度數, 拍照"
      },
      {
        "id": "夜班_006",
        "text": "23:00 巡邏R樓-2F",
        "type": "check",
        "required": true,
        "hint": "- R樓抄下公用水表, 拍照\n- 23:00 2F-10F梯廳燈手動全關, 各層住戶門前燈全關\n- [水電記錄表](https://docs.google.com/spreadsheets/d/1W8hfwUIcB2Y2gyWP6WGLY7njaT9Kc8Z8Iiq3H9rbDB0/edit?usp=sharing)\n  將水表及電錶度數填到**度數異動表**,水表(4位整數5位小數), 電錶填入若數字差異很大,\n  可能是看錯度數, 重新比對相片再填對"
      },
      {
        "id": "夜班_007",
        "text": "01:00 巡邏R樓-2F",
        "type": "check",
        "required": true,
        "hint": "再確認燈光關閉, 防火門關閉"
      },
      {
        "id": "夜班_008",
        "text": "03:00 巡邏 1F, B1, B2",
        "type": "check",
        "required": true,
        "hint": "含後門確認上鎻, 門口左側停車場共用牆避免被噴漆, 設備燈號異常拍照"
      },
      {
        "id": "夜班_009",
        "text": "05:00 天亮時關燈",
        "type": "check",
        "required": true,
        "hint": "1F燈光綠標籤手動關(4+2+1個)"
      },
      {
        "id": "夜班_010",
        "text": "06:00 除濕機倒水, 開B1車道門",
        "type": "check",
        "required": true,
        "hint": "手動開啟B1車道門(法定假日不用), 交誼廳及健身房除濕機倒水.\n人回到保全室再開B1車道門"
      },
      {
        "id": "夜班_011",
        "text": "07:00 交接下哨, 黃色名牌換成日班",
        "type": "check",
        "required": true,
        "hint": "避免下班被打電話"
      }
    ]
  },
  {
    "id": "全日",
    "title": "保全全日勤務 版本2026-08-08",
    "role": [
      "day",
      "night",
      "committee"
    ],
    "items": [
      {
        "id": "全日_001",
        "text": "檢查表打勾方式",
        "type": "check",
        "required": true,
        "hint": "保全勤務不分日夜班全部必讀, 以避免設備故障不知處理方式, 以及交接項目無法隔班交接\n- 當班檢查表: 每一項執行完打勾, 故障或無法執行要在紙本記錄本說明, 不可提早太多\n  或拖延太久打勾\n- 下一班檢查表: 只要勾交接項目, 若前一班有交接學習事項, 學會後該項目打勾, 教給下一班\n- 全日檢查表: 印成紙本每人一份, 自發行日, 在上面標注不懂的問題, 一個月內會做\n- 新的異動會獨立打勾項目, 在下一版考量合併"
      },
      {
        "id": "全日_002",
        "text": "上班前須熟悉智生活操作，加入 Line群組",
        "type": "check",
        "required": true,
        "hint": "加入**管委會群組**, 檢查表內說的拍照,就隱含要上傳群組, 值班期間針對群組設定**釘選聊天室**, **開啟提醒**, 下班時為避免干擾, **關閉提醒**"
      },
      {
        "id": "全日_003",
        "text": "掌握人員進出, 目標是認識所有住戶",
        "type": "check",
        "required": true,
        "hint": "掌握人員進出, 值勤時不可睡覺, 社區監控器會紀錄, 住戶經過, 要從座位站起來打招呼,\n比方說(您好,我是新來的警衛,請問是幾樓之幾住戶,我看看有沒有您的包裹),\n目標是認識所有住戶, 自行準備筆記本劃上樓層戶號, 可說明目前認得住戶百分比"
      },
      {
        "id": "全日_004",
        "text": "了解社區電腦密碼,離開位置鎖定螢幕,了解其他常用密碼放置位置, 警衛室人員進出, 不可張貼密碼",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_005",
        "text": "值勤期間須閱讀 Line 群組事項(尤其是機動班要往前回捲,了解社區動態, 被住戶詢問時才不會一問三不知)",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_006",
        "text": "交接上哨時，填寫工作日誌，更換黃色名牌，以便離開警衛室時，他人可透過名牌聯絡",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_007",
        "text": "離開警衛室時超過10公尺(到大鐵門處)，門需上鎖, 就算離開一下、也要記得鎖門！如果電腦、 包裹遺失，物管要全權負責",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_008",
        "text": "為避免讓住戶領包裹時吸到致癌的二手煙, 如果在警衛室門外抽菸時須關門, 為提昇社區形象, 盡量不在大門口抽煙, 不可到頂樓抽菸",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_009",
        "text": "當日發現異常須紀錄在值班日誌上，照相到 Line 群組，處理完畢回報到 Line 群組",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_010",
        "text": "若有社區維修檢測人員到場，應撥空陪同，拍照紀錄，詢問若該設備故障時應急處理措施, 學會新項目拍照到群組",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_011",
        "text": "平時應監控螢幕了解各螢幕監控地點，必要時協助手動控制允許車輛進出（確認是否住戶、訪客或社區工程維修車）",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_012",
        "text": "警衛前車道為本社區私有地及消防通道(消防栓附近5公尺不得停車)，不可停車，須管制驅離, 為鄰里和諧, 可讓鄰居暫停接送, 但不含商家客人(詳閱Line群組記事本)",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_013",
        "text": "社區中庭並無合法停車位，放置橘色禁止停車牌(上面有相關公告), 僅允許訪客暫停，須登記每次僅能暫停30分鐘，於擋風玻璃處放置牌子標示車主聯絡方式",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_014",
        "text": "社區B1,B2未劃車位處不可停車，僅允許已申請裝修者暫停，不可擋住消防通道，於擋風玻璃處放置牌子標示車主聯絡方式",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_015",
        "text": "外送食物人員，統一放置於1F大門進入後左側桌子，並應標示幾樓之幾，保全人員不可幫外送人員開電梯門，以避免物品遺失爭議",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_016",
        "text": "快遞大型物品在警衛室放不下時，暫放置聯誼廳，門需上鎖避免遺失",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_017",
        "text": "保全人員於上班前在手機安裝**智生活管理版**，郵件包裹/寄放物品/退貨都必須以電子方式登記，並在物品上貼上智生活給的編號，住戶領取時，除智生活結單外，也須在紙本上簽名",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_018",
        "text": "智生活故障時，以紙本先行，編號暫時以1000往後編, 系統恢復之後須補登及更正編號",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_019",
        "text": "每隔兩個月自助瓦斯抄表,除公告紙本外,也提供使用智生活填寫抄表,抄表完要使用電腦智生活管理版印表,與紙本一起交給瓦斯公司",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_020",
        "text": "社區信箱感應開鎖容易故障,請住戶開鎖後不要上鎖",
        "type": "check",
        "required": true,
        "hint": "投信時, 不要把抽屜關到底鎖住.\n若該戶信箱鎖住, 投信時, 不要全部放入抽屜, 避免無法再取出"
      },
      {
        "id": "全日_021",
        "text": "信箱旁側門永遠維持關閉",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_022",
        "text": "車道門禁管制",
        "type": "check",
        "required": true,
        "hint": "- 車道大鐵門固定不關:\n  車道大鐵門固定不關(**車道 大門**), 但每月機電保養時測試開啟: 因為會造成門禁監控系統脫離,\n  正常時應於平日 06:00-21:00 手動開啟(下雨天避免車道輪子打滑空轉要預先開啟, 因常故障因此開啟時間和B1升降門不一致)\n- 手動開關B1車道門(**車道 地下室**), 平日上下班時段 06:00-09:30 及 18:00-21:00\n  開啟。下雨天偶而感應不良不會自動關閉, 此時攝影機畫面上方數字會是0, 按一下桌面下的開關即可重新關閉"
      },
      {
        "id": "全日_023",
        "text": "燈光管制",
        "type": "check",
        "required": true,
        "hint": "- B1-B2燈光手動關閉: 僅留綠標燈不關\n- 自動戶外景觀燈以季節設定開啟, 陰雨天可提早開, 21:00關閉, 若故障時, 要手動操作Ba9800第三個**燈光控制系統圖**\n  - 3-5月 18:05, 6-8月 18:35\n  - 9-11月 17:40, 12-2月 17:15\n- 1F燈光黃標籤手動開關: 開燈時間比照自動景觀燈-22:00關閉\n- 1F燈光綠標籤手動開關: 開燈時間比照自動景觀燈-關閉時間參考以下\n  - 3-5月 05:40, 6-8月 05:15\n  - 9-11月 06:00, 12-2月 06:30\n  - 陰雨天延後關\n- 1F外圍走道手動開關: 18:00(天暗)-22:00開啟, 開關在1F健身房前面走道變電箱打開左下角三個燈(綠標籤), 變電箱的門要正確鎖好\n- 1F梯廳藝術燈手動開關: 固定開,開關在右上方\n- 2F-10F梯廳燈手動開關: 18:00(天暗)-23:00開啟(各層樓左邊有兩個開關, 打開右邊的一個,左邊關掉)"
      },
      {
        "id": "全日_024",
        "text": "自動灑水系統及人工灑水",
        "type": "check",
        "required": true,
        "hint": "- 1F 自動灑水馬達計時器在機電室每天於09:00-09:30及16:45-17:00開啟(注意校正時間)\n- 若故障時且沒下雨要手動開關, 灑水後水管擺放到陰涼處避免曝曬\n- 頂樓水龍頭灑水比照 1F 時間, 灑水後水管擺放到水表間避免曝曬"
      },
      {
        "id": "全日_025",
        "text": "不斷電系統(UPS)延長線,不插額外設備(尤其是含馬達設備), 以免影響寶貴的備用時間(用來正常關機)及損壞UPS",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_026",
        "text": "交接下哨時，與下一班清點智生活包裹數及已知異常現象",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_027",
        "text": "機電房與抽水馬達非專業人員請勿操作",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_028",
        "text": "巡邏各樓層時,要往兩個樓梯間的防火門要閉合(但不能鎻）",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_029",
        "text": "Line App, 異常時, 貼照片, 相片方向轉正",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_030",
        "text": "門禁系統, 關機重新開啟方式: 輸入密碼,點**門禁**",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_031",
        "text": "門禁系統, 暫時開門10秒功能: 點**大門口2**, 點**開門控制**",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_032",
        "text": "門禁系統, 永久開門功能: 右鍵點**機器操作設定**, 點門禁模式**停用**",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_033",
        "text": "門禁系統, 從**機器操作設定** 變回**開門控制**: 點樹狀上一層的**門禁連線控制器**, 再點回來**大門口2**",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_034",
        "text": "電腦網路故障: 重新點社區OPPO手機的無線分享",
        "type": "check",
        "required": true,
        "hint": "該手機無線分享有設定最大流量,超出時會停止分享, 此時要再設定分享"
      },
      {
        "id": "全日_035",
        "text": "郵件分發",
        "type": "check",
        "required": true,
        "hint": "分信時請看清楚，不要被住戶反應分錯信\n- 一般住戶, 放入1F信箱區, 部份住戶要求轉投信箱, 請注意依照信箱上標注轉投\n- 寫27號沒寫樓層的信，如非管委會, 請轉到1F住戶\n- 署名管委會信件一般轉由物業秘書分發\n- 放到信箱區管委會格子的文件, 通常是給委員傳閱使用, 必須要在 Line 群組說明給哪位委員\n- 住戶反應非住戶信件, 改放到**非住戶(目前標注房東)**紙盒,\n  由日班正常班通知相關人取回, 已通知信件在該信件上作記號\n- 發現信箱區上方堆放信件, 須處理再度分發"
      },
      {
        "id": "全日_036",
        "text": "值班時若帶耳機聽教學影片，請以不影響接聽電話方式進行，不要被住戶反應人在管理室卻沒接電話",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_037",
        "text": "熟悉 4 本簿冊填寫查詢更新方式",
        "type": "check",
        "required": true,
        "hint": "- 住戶資料\n- 廠商修繕\n- 臨時停車, 停到中庭要登記車號,戶號等\n- 磁扣維修, 任何權限異動維修要記錄(含委員)以了解設備故障頻率"
      },
      {
        "id": "全日_038",
        "text": "攝影監控有9+16+19個鏡頭(其中中間頻道2/3偶有故障), 須了解每個鏡頭拍攝位置與如何放大以及回放",
        "type": "check",
        "required": true
      },
      {
        "id": "全日_039",
        "text": "看完智生活規約",
        "type": "check",
        "required": false,
        "hint": "網頁管理版/規約辦法, 目前共7份文件\n- 敦美苑規約\n- 圓山敦美苑社區管理費用酌收暨相關事項辦法\n- 寵物飼養管理辦法\n- 交誼廳管理辦法\n- 健身房使用管理辦法\n- 裝修管理辦法\n- 地下停車場管理辦法"
      },
      {
        "id": "全日_040",
        "text": "看完電腦教學影片",
        "type": "check",
        "required": false,
        "hint": "電腦上桌面/教學目錄, 請勿使用公用電腦觀看與公務無關影片\n- 日班SOP\n- 即時回放\n- 智生活登錄及包裹\n- 開關前澆花系統\n- 門禁開關車道電梯"
      },
      {
        "id": "全日_041",
        "text": "停電切換到不斷電系統時,將門禁系統(Ba9800),錄影系統(DVR)正常關機, 電力回復時, 校正系統時間",
        "type": "check",
        "required": false
      },
      {
        "id": "全日_042",
        "text": "磁扣維修須留下記錄, 常見的應急設定(如B2門禁維修), 各班別須熟悉, 須付費的增減磁扣由管委會設定",
        "type": "check",
        "required": false
      },
      {
        "id": "全日_043",
        "text": "基本素養:每個鑰匙(幾把)及各樓層燈光設備開關位置",
        "type": "check",
        "required": false
      },
      {
        "id": "全日_044",
        "text": "Line App 功能: 轉傳, 相片旋轉上傳, 擷取部份圖片, 在圖片劃線, 在圖片標示文字, 多張相片一起上傳",
        "type": "check",
        "required": false
      },
      {
        "id": "全日_045",
        "text": "熟悉軟體操作: 手機智生活管理版",
        "type": "check",
        "required": false
      },
      {
        "id": "全日_046",
        "text": "熟悉軟體操作: 網頁智生活管理版",
        "type": "check",
        "required": false
      },
      {
        "id": "全日_047",
        "text": "熟悉軟體操作: 電腦中央監控系統(Ba-9800)",
        "type": "check",
        "required": false,
        "hint": "[電腦中央監控系統 共 2 項](http://d27:8888/docs/電腦中央監控系統)"
      },
      {
        "id": "全日_048",
        "text": "熟悉軟體操作: 門禁管制系統(Ds-2000)",
        "type": "check",
        "required": false,
        "hint": "[門禁系統使用手冊 共 4 項](http://d27:8888/docs/門禁系統使用手冊)"
      },
      {
        "id": "全日_049",
        "text": "緊急廣播主機",
        "type": "check",
        "required": false,
        "hint": "- 左側電源定位打開, 下方選擇區域（如B1)或右上按綠色全區, 拿起麥克風,\n  按下麥克風上按鍵播音\n- 每月機電保養時測試及每年區權會使用\n- 練習: 交班時找下一班測試 B1 廣播, 正式時：可選全區"
      },
      {
        "id": "全日_050",
        "text": "電梯門禁卡解鎻: 拿電梯鑰匙, 開啟面板, 將刷卡機關閉",
        "type": "check",
        "required": false
      }
    ]
  },
  {
    "id": "住戶須知",
    "title": "住戶須知 版本2026-08-08",
    "role": [
      "committee",
      "resident"
    ],
    "items": [
      {
        "id": "住戶須知_001",
        "text": "隨手關門",
        "type": "check",
        "required": true,
        "hint": "- 1F大廳門(非常重要), 請各住戶互相提醒隨手關門, 若發現沒關門, 請幫忙關門,\n  並通報保全查錄影, 避免未來社區門戶大開\n- 1F通往B1門,平常要關門,但請勿上鎖"
      },
      {
        "id": "住戶須知_002",
        "text": "社區垃圾分類原則",
        "type": "check",
        "required": true,
        "hint": "- 廚餘垃圾不可以丟入塑膠袋, 可將塑膠袋放置隔壁蒐集區, 丟完若須洗手, 左邊有洗手台,\n  洗手區燈光開關在玻璃回收筒上方, 用完請關燈\n- 不回收垃圾需自行聯繫, 如沙發、床墊、衣櫃、櫥櫃、厚重實心木板、陶瓷花瓶瓦罐。\n  前一天打給大龍清潔隊(1999)。晚上八點後拿至守衛室前牆邊放, 告知保全一下。\n  上面貼紙條寫：已聯絡清潔隊回收"
      },
      {
        "id": "住戶須知_003",
        "text": "包裹通知",
        "type": "check",
        "required": true,
        "hint": "- 安裝[智生活](https://www.smartdaily.com.tw/)App 之後, 可以在智生活的包裹頁面找\n  到包裹的通知\n- 若不需要對講機通知包裹沒領, 請告知守衛室, 但必須留通知方式避免包裹逾期未領,\n  建議以免費的App方式通知\n- 若通知方式須額外耗費社區電話費, 統計後若數量過大將收取郵電費用\n- 若同一戶要求不可代領, 請特別告知, 由管委會確認是否實施更嚴格的身份確認方式,\n  最嚴格的方式可以要求使用智生活認證加磁扣感應再加上領取人相片"
      },
      {
        "id": "住戶須知_004",
        "text": "Hometek 對講機使用方式及幫訪客開門方式",
        "type": "check",
        "required": true,
        "hint": "- 平常可預先設定按 C-選台再按2看大門口2\n- 監看方式: 按 4-監看, 再按 5-切換, 就可以切換大門口2或自家樓層門口鏡頭\n- 開門方式: 切換到到大門口2鏡頭, 再按 2-開門 即可打開大門口2\n- 若保全不在開客梯電梯方式: 請訪客聯絡你, 確認人已經進去客梯(靠大門口的), 然後你\n  再到自己樓層按一下下樓, 電梯即可抵達自家樓層\n- 若保全在打開客梯方式: 可以按 1-說話, 請保全按門禁系統, A梯, '開門控制' 遠端\n  打開一次性客梯解鎖任意樓層\n- 切勿由訪客自行告知保全讓保全自行開門, 以避免讓保全養成習慣由陌生人告知開門,\n  造成社區安全漏洞"
      },
      {
        "id": "住戶須知_005",
        "text": "遵循消防法規",
        "type": "check",
        "required": true,
        "hint": "- 請各住戶平常就應該依照消防法規收起門前各項雜物, 以免影響社區消防安檢複查進行\n- 各樓層的消防防火門, 依法規應隨時關閉(含R樓), 火災發生時, 才能夠從安全梯逃生而不吸到濃煙\n- R樓梯廳往外面的門, 平常要關門, 這是115年消防安檢缺失, 曬棉被一定會較不方便"
      },
      {
        "id": "住戶須知_006",
        "text": "郵件包裹/寄放物品/退貨",
        "type": "check",
        "required": true,
        "hint": "- 都必須讓保全以電子方式(智生活)登記, 領取時紙本簽名\n- 若平信, 信件地址人已搬走, 在地址處標注**已搬走**,\n  請拿到警衛室放置**非住戶(目前標注房東)**紙盒, 由日班正常班通知相關人取回"
      },
      {
        "id": "住戶須知_007",
        "text": "中庭停車務必主動找保全室管理員登記",
        "type": "check",
        "required": true,
        "hint": "社區中庭並無合法停車位，請依橘色禁止停車牌上告示, 若須停車,請**主動告知保全**,\n若保全不在,請在 Line 社群告知"
      },
      {
        "id": "住戶須知_008",
        "text": "若發現保全睡覺情況",
        "type": "check",
        "required": true,
        "hint": "請拍照並即時上傳社區Line群組以記錄時間,語氣和諧以詢問包裹問題方式提醒保全回答問題,\n以利即時改善"
      },
      {
        "id": "住戶須知_009",
        "text": "若發現保全不在且沒鎖門",
        "type": "check",
        "required": true,
        "hint": "請聯絡黃色名牌電話,藉由詢問事情,提醒沒鎖門,以立即改善社區風險,並上傳群組,以利考核汰換"
      },
      {
        "id": "住戶須知_010",
        "text": "車道進出注意",
        "type": "check",
        "required": true,
        "hint": "- 進出B2到B1騎機車從B2往B1時,B1感應燈號有時不會顯示紅燈,請汽機車從B1到B2時小心慢行避免相撞\n- 偶而B1車道旁紅綠警示燈故障, 開車進出車道請養成習慣一律慢行, 不要太相信燈光號誌\n- 若下雨天 21:00 後 B1 車道已經顯示 '00' 秒, 超過一分鐘仍未關門, 請提醒保全關門,\n  以免閒雜人等透過 B1 車道入口進入社區"
      },
      {
        "id": "住戶須知_011",
        "text": "社區目前停用設備如下",
        "type": "check",
        "required": true,
        "hint": "停用原因主要是頻繁故障, 維修不易\n- 信箱電子鎻\n- 大鐵門"
      },
      {
        "id": "住戶須知_012",
        "text": "避免與物管人員發生借貸關係",
        "type": "check",
        "required": true,
        "hint": "- 如物管人員以各種原因借錢, 即便金額再小, 統一回答物管公司不允許\n- 如已經借款, 屬私人借貸, 自行負責, 但請告知管委會回報物管公司"
      },
      {
        "id": "住戶須知_013",
        "text": "看完智生活規約",
        "type": "check",
        "required": false,
        "hint": "手機版/我的社區/規約辦法, 版本差異處, 以牆上為準\n網頁管理版/規約辦法, 目前共7份文件\n- 會議規則/敦美苑規約\n- 財務管理辦法/圓山敦美苑社區管理費用酌收暨相關事項辦法\n- 共用部份管理規則/交寵物飼養管理辦法\n- 共用部份管理規則/交誼廳管理辦法\n- 共用部份管理規則/健身房使用管理辦法\n- 停車場管理辦法/地下停車場管理辦法\n- 住戶房屋修繕管理辦法/裝修管理辦法"
      }
    ]
  }
];
